module.exports = __webpack_public_path__ + "static/img/3_7_2.6bacfc53.jpg";